export const ago = (iso) => {
  if (!iso) return "never";
  const m = Math.round((Date.now() - new Date(iso)) / 60000);
  return m < 1 ? "just now" : m < 60 ? `${m}m ago` : m < 1440 ? `${Math.round(m / 60)}h ago` : `${Math.round(m / 1440)}d ago`;
};

export const dur = (s) => (s < 60 ? `${s}s` : s < 3600 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`);

export const clock = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });

export const EV_STYLE = {
  session_start: ["text-accent2", "SESSION"], page_view: ["text-white/70", "VIEW"], page_leave: ["text-white/35", "LEAVE"],
  click: ["text-brand", "CLICK"], rage_click: ["text-[#FF2BD6]", "RAGE"], api_error: ["text-red-400", "API ERR"],
  js_error: ["text-red-400", "JS ERR"], idle: ["text-white/30", "IDLE"], coach_ask_mari: ["text-amber-300", "ASK MARI"],
  coach_dismissed: ["text-white/40", "COACH ✕"], form_submit: ["text-brand", "SUBMIT"],
};

export const SEV = { high: "border-red-400 text-red-300 bg-red-400/5", medium: "border-amber-300 text-amber-200 bg-amber-300/5", low: "border-white/30 text-white/60 bg-white/5" };

export const Panel = ({ title, right, children, testid, className = "" }) => (
  <section className={`panel p-5 relative overflow-hidden ${className}`} data-testid={testid}>
    <div className="flex items-center justify-between mb-4"><p className="label-xs">{title}</p>{right}</div>
    {children}
  </section>
);

export const evText = (e) => {
  if (e.event === "page_view") return e.page_name || e.page;
  if (e.event === "page_leave") return `${e.page_name || e.page} · ${dur(Math.round((e.ms || 0) / 1000))} visible`;
  if (e.event === "session_start") return e.meta?.ua?.match(/\(([^)]+)\)/)?.[1] || "new session";
  if (e.event === "idle") return "switched tab / went idle";
  return [e.label, e.target].filter(Boolean).join(" · ") || e.page;
};
